import { Map } from 'immutable';
import { createReducerBySpec } from '@Utils/Redux/reducerFactory';

import {
  batchModalSetCurrentStructureOptionsReducerType,
  batchModalSetBatchFileReducerType,
  batchModalSetOverwriteOptionsReducerType,
} from './BatchModalConstants';

export const initialState = Map({
  batchFile: null,
  overwriteOptions: false,
  currentStructureOptions: null,
});

const spec = {
  [batchModalSetBatchFileReducerType]: (state, action) => {
    const { batchFile } = action.payload;
    return state.set('batchFile', batchFile);
  },
  [batchModalSetOverwriteOptionsReducerType]: (state, action) => {
    const { overwriteOptions } = action.payload;
    return state.set('overwriteOptions', overwriteOptions);
  },
  [batchModalSetCurrentStructureOptionsReducerType]: (state, action) => {
    const { currentStructureOptions } = action.payload;
    return state.set('currentStructureOptions', currentStructureOptions);
  },
};

export default createReducerBySpec(spec, initialState);
